import React from "react";

const UserAppSection = () => {
  return (
    <div className="user-app-group">
      {/* Background images */}
      <div className="app-left">
        <img
          src="/img/bg/app-left.png"
          className="img-fluid"
          alt="Omshree Cab"
        />
      </div>
      <div className="app-right">
        <img
          src="/img/bg/app-right.png"
          className="img-fluid"
          alt="Omshree Cab"
        />
      </div>

      <div className="row">
        {/* Text & action buttons */}
        <div className="col-lg-7">
          <div className="userapp-heading">
            <h2 data-aos="fade-down">
              Travel Comfortably with Omshree Cab Service
            </h2>
            <p data-aos="fade-down">
              Omshree Cab offers reliable and affordable taxi services for
              local rides, airport transfers, and outstation trips. Enjoy
              comfortable vehicles, professional drivers, and safe journeys
              every time you travel with us.
            </p>

            <div className="download-btn">
              <div className="app-avilable" data-aos="fade-down">
                <a href="/booking">
                  <button className="btn btn-primary">
                    Book Your Ride
                  </button>
                </a>
              </div>

              <div className="app-avilable" data-aos="fade-down">
                <a href="/contact-us">
                  <button className="btn btn-outline-primary">
                    Contact Us
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Cab illustration */}
        <div className="col-lg-5 d-none d-lg-block">
          <div className="car-holder">
            <img
              className="app-car img-fluid"
              src="/images/app-car.png"
              alt="Omshree Cab Service"
              data-aos="fade-down"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAppSection;